var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTableFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.13139 0.0578454L5.46368 2.75234C5.55032 2.85282 5.4722 3 5.33229 3H0.667709C0.5278 3 0.449678 2.85282 0.536322 2.75234L2.86861 0.0578454C2.93608 -0.0192818 3.06463 -0.0192818 3.13139 0.0578454Z",
    fill: "#908CA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86861 7.94216L0.536322 5.24766C0.449678 5.14718 0.5278 5 0.667709 5H5.33229C5.4722 5 5.55032 5.14718 5.46368 5.24766L3.13139 7.94216C3.06392 8.01928 2.93537 8.01928 2.86861 7.94216Z",
    fill: "#908CA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTableFilter);
export default __webpack_public_path__ + "static/media/icon-table-filter.d4489570c5afc30f5a67b3ce980cc05d.svg";
export { ForwardRef as ReactComponent };